// extracted by mini-css-extract-plugin
export default {"sharedAccountCard":"style_sharedAccountCard__rq3jy","groupItemIcon":"style_groupItemIcon__vdy1d"};